import React from 'react'
import { Link } from 'react-router-dom'
import { Typography } from '@material-ui/core'
import noImage from 'assets/img/no-image.jpg'
import { ROUTES } from 'routes'

import { useStyles } from './OrganizationCard.style'

const OrganizationCard = ({ organization }) => {
  const classes = useStyles()
  const { name, id, handle } = organization

  const imageUrl =
    Array.isArray(organization.organizationProfileImages) &&
    organization.organizationProfileImages.length > 0
      ? organization.organizationProfileImages[0]
      : noImage

  return (
    <Link className={classes.organization} to={`${ROUTES.ORGANIZATIONS.PROFILE}/${handle || id}`}>
      <div className={classes.image} style={{ backgroundImage: `url(${imageUrl})` }} />
      <Typography variant='h6' color='primary' title={name} className={classes.name}>
        {name}
      </Typography>
    </Link>
  )
}

export default OrganizationCard
